<template>
    <div class="wedding">
        <z-title title="婚庆预定结算" ref="title"></z-title>
        <el-card class="content1" ref="search">
            <div class="flex-n fac">
            <el-input
                    size="medium"
                    class="ele-input mr-10"
                    placeholder="输入新郎或新娘姓名"
                    maxlength="8"
                    clearable
                    title="输入新郎或新娘姓名"
                    prefix-icon="el-icon-search"
                    v-model="maleFemaleName">
            </el-input>
            <el-input
                    size="medium"
                    class="ele-input mr-10"
                    type="number"
                    placeholder="输入电话号码"
                    clearable
                    title="输入电话号码"
                    prefix-icon="el-icon-search"
                    maxlength="11"
                    v-model="maleFemalePhone">
            </el-input>

            <div class="textnowrap">订单状态：</div>
            <order-confirm-state clearable class="mr-10" size="medium" v-model="orderState"
                                 placeholder="请选择"></order-confirm-state>
                <div class="textnowrap">订单日期：</div>
                <el-date-picker
                        size="medium"
                        class="mr-10 date"
                        v-model="dateRange"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                >
                </el-date-picker>
         </div>
            <div class="flex-n fac mt-10">

                <div class="textnowrap">下单日期：</div>
                <el-date-picker
                        size="medium"
                        class="mr-10 date"
                        v-model="orderDateRange"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                >
                </el-date-picker>
                <el-button type="primary" class="ele-btn2" @click="searchWeddingOrder">查询</el-button>

            </div>
        </el-card>
        <!--列表-->
        <el-card class="mt-10">
            <el-table
                    v-loading="loading"
                    :height="height+'px'"
                    highlight-current-row
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="dataList"
                    style="width: 100%">
                <el-table-column
                        fixed
                        align="center"
                        prop="maleName"
                        label="新郎姓名"
                        width="100">
                </el-table-column>
                <el-table-column
                        fixed
                        align="center"
                        prop="femaleName"
                        label="新娘姓名"
                        width="100">
                </el-table-column>
                <el-table-column
                        label="订单状态"
                        min-width="100"
                        align="center">
                    <template slot-scope="scope">
                        <template v-for="item,index in confirmStateList" v-if="item.dicCode==scope.row.confirmState">
                            <el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='04'" type="warning">
                                {{item.dicName}}
                            </el-tag>
                            <el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='03'" type="info">
                                {{item.dicName}}
                            </el-tag>
                            <el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='02'" type="danger">
                                {{item.dicName}}
                            </el-tag>
                            <el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='01'" type="success">
                                {{item.dicName}}
                            </el-tag>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="手机号码"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="预定时间段"
                        width="230"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.orderDate}} {{scope.row.weddingBeginTime}}~{{scope.row.weddingEndTime}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="houseName"
                        label="预定场地"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="典礼开始时间"
                        width="160"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.beginTime}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="weddingPackageName"
                        label="预定套餐"
                        width="180"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="createUserName"
                        label="接待人员"
                        width="100"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="createUserPhone"
                        label="接待电话"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="downPayment"
                        label="定 金"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="应收款"
                        width="120"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.weddingMoney||0}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="实收款"
                        width="120"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.realPayment||0}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="退款金额"
                        min-width="150"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.refundMoney||0}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="差额"
                        width="120"
                        align="center">
                    <template slot-scope="scope">
                        {{(scope.row.realPayment||0)-(scope.row.orderMoney||0)-(scope.row.refundMoney||0)}}
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="190"
                        align='center'
                >
                    <template slot-scope="scope">
                        <div style="text-align:left;padding: 5px 0">
                            <template v-if="scope.row.confirmState!='02'&&scope.row.confirmState!='01'">
                                <el-button class="ele-btn-small" type="primary" size="mini"
                                          @click="toConfirmCollection(scope.row.id,scope.row.weddingOrderId)">
                                    确认收款
                                </el-button>

                                <el-button class="ele-btn-small" type="primary" size="mini"
                                           @click="gotoSettlement(scope.row.orderId,scope.row.weddingOrderId)">结算
                                </el-button>
                                <el-button class="ele-btn-small" type="primary" size="mini"
                                           @click="toCancel(scope.row.orderId,scope.row.weddingOrderId)">
                                    取消
                                </el-button>
                            </template>
                            <div v-else-if="scope.row.confirmState=='02'" style="text-align:left;padding: 5px 0">
                                <el-button class="ele-btn-small" type="primary" size="mini"

                                           @click="getDetail(scope.row.id,scope.row.weddingOrderId)">收款明细
                                </el-button>
                            </div>
                            <template v-else>
                                <el-button class="ele-btn-small" type="primary" size="mini"
                                           @click="toSupplementary(scope.row.id,scope.row.weddingOrderId)">补账
                                </el-button>
                                <el-button class="ele-btn-small" type="primary" size="mini"

                                           @click="getDetail(scope.row.id,scope.row.weddingOrderId)">收款明细
                                </el-button>
                            </template>

                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-card>
        <!--确认收款-->
        <wed-confirm-collection :visible.sync="showConfirm" :id="orderId" :wed-id="wedId" @refreshList="getWeddingOrder"></wed-confirm-collection>
        <!--收款明细-->
        <wed-collection-detail :visible.sync="showDetail" :id="orderId" :wed-id="wedId" @refreshList="getWeddingOrder"></wed-collection-detail>
        <!--取消订单-->
        <wed-order-cancel :visible.sync="showCancel" :id="orderId" :wed-id="wedId" @refreshList="getWeddingOrder"></wed-order-cancel>
        <!--预定结算-->
        <wed-order-settlement :visible.sync="showSettlement" :id="orderId" :wed-id="wedId" @refreshList="getWeddingOrder"></wed-order-settlement>
<!--补账-->
        <wed-supplementary-account :visible.sync="showSupplementary" :id="orderId" :wed-id="wedId" @refreshList="getWeddingOrder"></wed-supplementary-account>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import OrderConfirmState from "../../components/data/orderConfirmState";
    import ExtraList from "../component/extra";
    import Payment from "../../components/data/payment";
    import Weddingbase from "../component/weddingbase";
    import Pagination from "../../components/pagination/pagination";
    import WedConfirmCollection from "./sub/WedConfirmCollection";
    import WedCollectionDetail from "./sub/WedCollectionDetail";
    import WedOrderCancel from "./sub/WedOrderCancel";
    import WedOrderSettlement from "./sub/WedOrderSettlement";
    import WedSupplementaryAccount from "./sub/WedSupplementaryAccount";

    export default {
        components: {
            WedSupplementaryAccount,
            WedOrderSettlement,
            WedOrderCancel,
            WedCollectionDetail,
            WedConfirmCollection,
            Pagination,
            Weddingbase,
            Payment,
            ExtraList,
            OrderConfirmState,
            ZTitle
        },
        name: "wedding",
        data() {
            var validatetel = (rule, value, callback) => {
                console.log(value)
                if (!this.$root.mobileformat.test(value) && value) {
                    return callback(new Error('请输入11位的有效手机号码'));
                }
                return callback();
            };
            return {
                loading: false,
                pageSize: 20,
                currentPage: 1,
                total: 0,
                height: 250,
                editstate: '新增',
                loading2: false,
                useMemberCard: false,
                showCodeChecked: false,
                maleFemaleName: '',
                maleFemalePhone: '',
                orderDate: '',
                dateRange: [],
                orderDateRange:[],
                orderState: "",

                packageId: "",
                confirmStateText: "",
                weddingCustomName: "",
                weddingBeginTime: "",
                orderId: '',
                wedId: '',

                info: {},
                extraArea: {},

                showdialog: false,
                stateName: '婚庆订单确认收款',
                //确认收款
                dataForm: {
                    confirmMoney: '',
                    remark: ''
                },
                //取消退款
                cancelForm: {
                    orderId: '',
                    confirmMoney: '',
                    remark: '',
                },
                showConfirm:false,//确认收款弹窗
                showDetail:false,//收款明细
                showCancel:false,//取消弹窗
                showSettlement:false,//结算弹窗
                showSupplementary:false,//补账弹窗

                settlementdialog: false,
                addtables: false,
                addpeople: false,
                showsetmeal: false,//显示套餐弹窗
                showextra: false,//额外合计项目弹窗
                orderForm: {
                    paylist: [],
                    extra: {}
                },
                orderData: [],
                rules: {
                    memberPhone: [{validator: validatetel, trigger: 'blur'},
                        {required: true, message: ' ', trigger: 'change'}],
                    confirmMoney: [{required: true, message: '收款金额不能为空', trigger: 'blur'}],
                    paylist:[{required: true, message: ' ', trigger: 'change'}],
                },
                confirmStateList: [],
                todooptions: [{
                    value: '1',
                    label: '新增婚庆'
                }, {
                    value: '2',
                    label: '编辑婚庆'
                }, {
                    value: '3',
                    label: '查看预定'
                }],
                dataList: [],
                sendcodestate: 0,//0,1是发送重新发送，2是倒计时开始
                showtime: 60,
                memberinfo: {},
                searchphone: false,
                cleartime: '',
            }
        },
        mounted() {
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
            var date=this.$TM.getDayArea();
            var mm=date.mm,yy=date.yy;
            if(mm==12){
                mm=1;
                yy++;
            }
            var date2=new Date(new Date(this.$TM.getDayArea(yy,mm+1,1).date).getTime()-24*60*60*1000);            this.dateRange=[date.yy+'-'+date.mm+'-1',date2.getFullYear()+'-'+(date2.getMonth()+1)+'-'+date2.getDate()];
            this.dateRange=[date.yy+'-'+date.mm+'-1',date2.getFullYear()+'-'+(date2.getMonth()+1)+'-'+date2.getDate()];
            this.getWeddingOrder();
        },
        watch: {
            showdialog(newval, oldval) {
                console.log(this.stateName)
                if (!newval) {
                    if (this.stateName == '婚庆订单确认收款')
                        this.$refs.ruleForm.resetFields();
                    if (this.stateName == '订单取消')
                        this.$refs.cancelForm.resetFields();
                }
            },
            settlementdialog(newval, oldval) {
                if (!newval) {
                    this.memberinfo = {};
                    this.searchphone = false;
                    this.showCodeChecked = false;
                    this.useMemberCard = false;
                    this.$refs.orderForm.resetFields();
                }
            },
            showtime(newval, oldval) {
                if (newval == 0) {
                    clearInterval(this.cleartime);
                    this.showtime = 60;
                    this.sendcodestate = 1;
                }
            },
            useMemberCard(newval, oldval) {
                if (!newval) {
                    clearInterval(this.cleartime);
                    this.memberinfo = {};
                    this.searchphone = false;

                    for (var i in this.orderForm.paylist) {
                        if (this.orderForm.paylist[i].dicCode == '06') {
                            this.orderForm.paylist.splice(i, 1);
                            break;
                        }
                    }
                }
            }
        },


        computed: {
            pickerOptions() {
                var that=this;
                return{
                    firstDayOfWeek: 1,
                    shortcuts: [
                        {
                            text: '今日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '昨日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24);
                                end.setTime(end.getTime() - 3600 * 1000 * 24);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num-1));
                                end.setTime(end.getTime() + 3600 * 1000 * 24 * (7-num));
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '上周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num+6));
                                end.setTime(end.getTime() - 3600 * 1000 * 24 * num);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                const start = new Date();
                                var year=start.getFullYear(),month=start.getMonth()+1;
                                var startDate=new Date(year+'-'+month+'-1');
                                var length=that.$TM.getMonthArea().length-1;
                                var dd=that.$TM.getMonthArea()[length].dd;
                                var endDate= new Date(that.$TM.getMonthArea()[length-(dd<7?dd:0)].date);
                                console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上月',
                            onClick(picker) {
                                const start = new Date();
                                console.log(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}))
                                var month=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].mm,
                                    year=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].yy;
                                var length=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}).length-1;
                                var dd=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length].dd;
                                var startDate=new Date(year+'-'+month+'-1');
                                var endDate= new Date(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length-(dd<7?dd:0)].date);
                                // console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        }
                    ]
                }
            },

            totalMoney(newval, oldval) {
                // console.log(this.info)
                var orderForm = this.orderForm;
                var value = this.info.orderMoney;
                var cardDiscount = this.memberinfo && this.memberinfo.cardDiscount ? this.memberinfo.cardDiscount : 10

                // var payTypes = this.info.payTypes;
                // for (var i in payTypes) {
                //     if (payTypes[i].payTypeCode == '01') {
                //         value += Number(payTypes[i].onePrice) * Number(payTypes[i].orderCount);
                //     }
                //     if (payTypes[i].payTypeCode == '02') {
                //         value += Number(payTypes[i].onePrice) * Number(payTypes[i].orderCount);
                //     }
                //     if (payTypes[i].payTypeCode == '03') {
                //         value += Number(payTypes[i].housePrice);
                //     }
                // }
                value += Number(this.orderForm.extraMoney);
                this.orderForm.needMoney = value;
                return value * (cardDiscount / 10).toFixed(2)
            },
            realMoney() {
                var value = 0;
                for (var i in this.orderForm.paylist) {
                    value += Number(this.orderForm.paylist[i].price||0);
                }
                this.orderForm.realMoney = value;
                console.log(value)
                return value;
            },
            balanceMoney() {
                var value = (Number(this.totalMoney) - (Number(this.info.realPayment) || 0)).toFixed(2)
                return value;
            }
        },
        methods: {
            validateCode(phone, code) {
                this.$axios.post('/sms/validCode', {
                    "phone": phone,
                    "code": code
                }).then(res => {
                    this.$message.success('手机号验证成功');
                    this.showCodeChecked = false;
                    this.searchphone = true;
                    this.showtime=0;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            searchMemberPhone() {
                this.loading2 = true;
                if (this.orderForm.memberPhone.length == 11) {
                    this.$axios.post('member/memberByPhoneAndStoreId/' , {
                        "storeId": this.$root.getStorage('storeId'),
                        "memberPhone": this.orderForm.memberPhone
                    }).then(res => {
                        console.log(res)
                        this.loading2 = false;
                        if(res.data){
                            if (res.data.cardType == '01') {
                                this.showCodeChecked = true;
                            } else {
                                this.searchphone = true;
                            }
                            this.memberinfo = res.data;

                        }else{
                            this.$message.error('该账户不是会员或者存在异常，请联系管理员');
                        }


                    }).catch(err => {
                        this.memberinfo = null;
                        this.$message.error(err.msg);
                        this.loading2 = false;
                    })
                } else {
                    this.memberinfo = null;
                    this.loading2 = false;
                }
            },
            sendCode(phone) {
                this.$axios.post('/sms/sendSms', {
                    "mobile": phone,
                    "type": "SEND_CODE"
                }).then(res => {
                    this.$message.success('验证码发送成功');
                    this.sendcodestate = 2;
                    this.cleartime = setInterval(() => {
                        this.showtime--;
                    }, 1000)
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            //查询婚庆预定列表
            getWeddingOrder() {
                this.loading = true;
                this.$axios.post('/wedding/findWeddingOrderList', {
                    "storeId": this.$root.getStorage('storeId'),
                    "pageNum": this.currentPage,
                    "pageSize": this.pageSize,
                    "maleFemaleName": this.maleFemaleName,
                    "maleFemalePhone": this.maleFemalePhone,
                    "orderDate": this.orderDate,
                    "orderDateBegin": this.dateRange ? this.dateRange[0] : '',
                    "orderDateEnd": this.dateRange ? this.dateRange[1] : '',
                    "createTimeBegin": this.orderDateRange?this.orderDateRange[0]:'',
                    "createTimeEnd": this.orderDateRange?this.orderDateRange[1]:'',
                    "orderState": this.orderState
                }).then(res => {
                    console.log('婚庆预定列表', res);
                    this.dataList = res.data.list;
                    this.total = res.data.total;
                    this.getStateList();
                    this.loading = false;
                }).catch(err => {
                    this.$message.error(err.msg);
                    this.loading = false;
                })
            },
            getStateList() {
                if (this.$root.getStorage('dic')) {
                    this.confirmStateList = this.$root.getStorage('dic').filter((item) => item.dicType == 'order_confirm_state');
                    // console.log(this.followStateList)
                    // this.wantLevelList=this.$root.getStorage('dic').filter((item)=>item.dicType=='want_level');
                } else {
                    this.$store.state.dicChange = true;
                    this.getAskList();
                }
            },
            //搜索
            searchWeddingOrder() {
                this.currentPage = 1;
                this.getWeddingOrder();
            },
            //显示结算页面
            gotoSettlement(orderId, wedId) {
                this.wedId = wedId;
                this.orderId = orderId;
                this.showSettlement = true;
                // //上半部基本信息
                // this.$axios.get('/wedding/orderWeddingDetail/' + wedId).then(res => {
                //     console.log('婚庆数据', res)
                //     var info = res.data;
                //     this.extraArea = {
                //         itemsExTree: info.extra
                //     }
                //     this.orderForm.extraMoney = info.exItemMoney;
                //     this.info = info;
                // }).catch(err => {
                //     this.$message.error(err.msg);
                // })
            },
            //确认收款
            toConfirmCollection(orderId,wedId){
                this.orderId = orderId;
                this.wedId = wedId;
                this.showConfirm = true;
            },
            //补账
            toSupplementary(orderId,wedId){
                this.orderId = orderId;
                this.wedId = wedId;
                this.showSupplementary = true;
            },
            //收款明细
            getDetail(orderId,wedId){
                this.orderId = orderId;
                this.wedId = wedId;
                this.showDetail = true;
            },
            //取消订单
            toCancel(orderId, wedId){
                this.orderId = orderId;
                this.wedId = wedId;
                this.showCancel = true;
            },

            //查询收款明细
            financeConfirmDetail(orderId, type, wedId) {
                this.showdialog = true;
                if (type == 0) {
                    this.stateName = '婚庆订单确认收款';
                }
                else if (type == 1) {
                    this.stateName = '确认收款明细';
                }
                else {
                    this.stateName = '订单取消';
                }
                this.orderId = orderId;
                this.wedId = wedId;
                console.log(orderId, wedId)
                //上面
                this.$axios.get('/weddingFinanceConfirm/financeWeddingConfirmDetail/' + wedId).then(res => {
                    console.log('订单收款明细', res)
                    this.orderData = res.data.list;
                }).catch(err => {
                    this.$message.error(err.msg);
                })

            },
            //婚庆预定结算
            orderSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var orderForm = this.orderForm;
                        var payment = [], extraArea = {},consumeMoney=0;
                        for (var i in this.orderForm.paylist) {
                            payment.push({
                                "payMoney": this.orderForm.paylist[i].price||0,
                                "paymentCode": this.orderForm.paylist[i].dicCode,
                                "paymentName": this.orderForm.paylist[i].dicName,
                            });
                            if(this.orderForm.paylist[i].dicCode=='06'){
                                consumeMoney= this.orderForm.paylist[i].price||0;
                            }
                        }
                        extraArea = JSON.parse(JSON.stringify(this.extraArea).replace(/itemsExTree/g, 'itemsExs'));
                        this.$axios.post('/weddingClear/weddingPayment', {
                            "storeId": this.$root.getStorage('storeId'),
                            "orderId": this.orderId,
                            "weddingOrderId": this.wedId,
                            "extraMoney": orderForm.extraMoney,//额外项目金额
                            "payment": payment,//支付方式
                            "memberInfo":{
                                "memberPhone":orderForm.memberPhone,
                                "consumeMoney":consumeMoney
                            },
                            "isMemberPay":this.useMemberCard?1:0,
                            "orderExtra": extraArea,//额外项目内容
                            "realMoney": orderForm.realMoney,//实收金额
                            "needMoney": orderForm.needMoney,//应收金额
                            "remark": orderForm.remark,
                            "balanceMoney": this.balanceMoney,
                            "orderPackage": orderForm.orderPackage,
                        }).then(res => {
                            this.$message.success('婚庆预定结算成功！');
                            this.settlementdialog = false;
                            this.searchWeddingOrder();
                        }).catch(err => {
                            this.$message.error(err.msg);
                        })
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });

            },
            //取消订单
            // cancelOrder(formName) {
            //     this.$refs[formName].validate((valid) => {
            //         if (valid) {
            //             var cancelForm = this.cancelForm;
            //             this.$axios.post('/weddingFinanceConfirm/preOrderCancel', {
            //                 "confirmMoney": cancelForm.confirmMoney,
            //                 "weddingOrderId": this.wedId,
            //                 "remark": cancelForm.remark
            //             }).then(res => {
            //                 this.$message.success('婚庆订单取消成功！');
            //                 this.state = '确认收款明细';
            //                 this.getWeddingOrder();
            //                 this.showdialog = false;
            //             }).catch(err => {
            //                 this.$message.error(err.msg);
            //             })
            //
            //         } else {
            //             this.$message.error('表单填写有误');
            //             return false;
            //         }
            //     });
            // },
            getTotal(data) {
                console.log(data)
                this.orderForm.extraMoney = data.nowPrice;
            },
            lookextra() {
                this.showextra = true;
            },
            //确认收款
            saveReceivable(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var dataForm = this.dataForm;
                        this.$axios.post('/weddingFinanceConfirm/saveWeddingReceivable', {
                            "confirmMoney": dataForm.confirmMoney,
                            "weddingOrderId": this.wedId,
                            "remark": dataForm.remark
                        }).then(res => {
                            this.showdialog = false;
                            this.$message.success('订单确认收款成功！');
                            this.getWeddingOrder();
                        }).catch(err => {
                            this.$message.error(err.msg);
                        })
                    } else {
                        return false;
                    }
                });
            },
            cancel() {
                this.$refs.ruleForm2.validate((valid) => {
                    if (valid) {
                        this.state = '确认收款明细';
                        this.showdialog = false;
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            getSummaries(param) {
                const {columns, data} = param;
                const sums = ['累计收款', '', '', '', ''];
                var sum = 0;
                for (var i = 0, len = data.length; i < len; i++) {
                    sum += Number((data[i].confirmType == 0 ? '' : '-') + Number(data[i].confirmMoney));
                }
                sums[5] = sum;
                return sums;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getWeddingOrder();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getWeddingOrder();
                console.log(`当前页: ${val}`);
            },

        },
        beforeDestroy() {
            clearInterval(this.cleartime);
        }

    }
</script>

<style scoped lang="scss">
    .member_bg {
        margin: 0 80px;
        box-shadow: none;
        background: #fefefe;
    }

    .el-divider__text {
        font-weight: 700 !important;
        color: #5295e7;
    }

    .wedding {
        .content1 {
            .textnowrap {
                font-size: 13px;
                color: #333;
            }
            .date {
                min-width: 100px;
            }
        }
    }
</style>